const isPathExistInUrl = url => {
  const urlObj = new URL(url);
  if (urlObj.pathname === '/') {
    return false;
  }
  return true;
};

export default isPathExistInUrl;
